export default {
  entities: [],
}
